import LangStorage from "../../i18n/lang/index";
import navCom from "@components/navCom/navCom";
export default {
    components: {
        navCom
    },
    data() {
        return {
            lang: "cn",
            toggle_nev: false,
            theme: "blue",
            logoUrl: "",
            examName: "",
            domain: "",
            font_range: "",
            batchCode:"",
            exam_type: "",
            font_type: "",
            url_name: "",
            excuseExam: "",
            hideGradeDomain: ["xjrccb", "yrrcb.ata-test.net"],
            m2_mode: "horizontal",
        };
    },
    computed: {
        activeIndex: {
            get() {
                // this.getData();
                return this.$store.state.common.headerState;
            }
        },
        isHideExam: {
            get() {
                if (this.$store.state.examInfo.currentExamInfo.function_module) {
                    return this.$store.state.examInfo.currentExamInfo.function_module.filter(item => {
                        return item.module_type == "entry_examination_module";
                    })[0].selected;
                } else {
                    return 0;
                }
            }
        },
        isHideAdmissionTicket: {
            get() {
                if (this.$store.state.examInfo.currentExamInfo.function_module) {
                    return this.$store.state.examInfo.currentExamInfo.function_module.filter(item => {
                        return item.module_type == "examination_permit_module";
                    })[0].selected;
                } else {
                    return 0;
                }
            }
        },
        isHideGrade: {
            get() {
                if (this.$store.state.examInfo.currentExamInfo.function_module) {
                    return this.$store.state.examInfo.currentExamInfo.function_module.filter(item => {
                        return item.module_type == "results_release_module";
                    })[0].selected;
                } else {
                    return 0;
                }
            }
        },
        m2_router_link_list: {
            get() {
                return [{
                    to: {
                        name:this.batchCode? 'batch_main':'main',
                        params: {
                            projectCode: this.domain,
                            batchCode:this.batchCode
                        }
                    },
                    menu_name: this.$t('header.home'),
                    isShow: true,
                    index: "1"
                },
                {
                    to: {
                        name: 'default_moreAnnoucement'
                    },
                    menu_name:this.$t('header.noticeAnnouncemen'),
                    isShow: true,
                    index: "21"
                },
                {
                    to: {
                        name: "default_morePolicySystem"
                    },
                    menu_name: "政策制度",
                    isShow: true,
                    index: "22"
                },
                {
                    to: {
                        name: "default_moreProblemSolving"
                    },
                    menu_name: "问题解答",
                    isShow: true,
                    index: "23"
                },
                {
                    to: {},
                    menu_name: "报名流程介绍",
                    isShow: true,
                    index: "10"
                }
                ];
            }
        },
        m2_router_link_list_itp: {
            get() {
                return [{
                    to: {
                        name:this.batchCode? 'batch_main':'main',
                        params: {
                            projectCode: this.domain,
                            batchCode:this.batchCode
                        }
                    },
                    menu_name: "首页",
                    isShow: true,
                    index: "1"
                },
                {
                    to: {
                        name: 'default_moreAnnoucement'
                    },
                    menu_name: "通知公告",
                    isShow: true,
                    index: "21"
                },
                {
                    to: {
                        name: "default_morePolicySystem"
                    },
                    menu_name: "政策制度",
                    isShow: true,
                    index: "22"
                },
                {
                    to: {
                        name: "default_moreProblemSolving"
                    },
                    menu_name: "问题解答",
                    isShow: true,
                    index: "23"
                },
      
                ];
            }
        }
    },
    methods: {
        changeLangEvent() {         
            this.$confirm(this.$t("message.switchLanguage"), this.$t("common.tip"), {
                confirmButtonText:this.$t("common.confirm"),
                cancelButtonText: this.$t("common.cancel"),
                type: "warning"
            })
                .then(() => {
                   
                    if (window.localStorage.getItem('user_lang') === "cn") {
                        this.lang = "en";
                        this.$i18n.locale = this.lang; //关键语句
                    } else {
                        this.lang = "cn";
                        this.$i18n.locale = this.lang; //关键语句
                    }
                    LangStorage.setLang(this.$i18n.locale); //把语言存到cookie
                })
                .catch(() => {
                    this.$message({
                        type: "info"
                    });
                });
        },
        getData: function () {
            // console.log(this.$route.name)
            if (this.$route.name === "main"||this.$route.name === "batch_main") {
                var setCurrentExamInfo = {
                    api_state: false,
                    domain: this.domain
                };
                this.$store.commit("setCurrentExamInfo", setCurrentExamInfo);
                this.getInfo();
            } else {
                let currentExamInfo = this.$store.state.examInfo
                    .currentExamInfo;
                this.logoUrl = currentExamInfo.logo_name;
                this.examName = currentExamInfo.exam_name;
                this.font_type = currentExamInfo.font_type;
                this.font_range = currentExamInfo.font_range;
                this.exam_type = currentExamInfo.exam_type;
                this.domain = currentExamInfo.domain;
                this.batchCode = currentExamInfo.batchCode;
                this.excuseExam = currentExamInfo.exempt_exam_is_open;
                if (currentExamInfo.url_name != null) {
                    this.url_name = "http://" + currentExamInfo.url_name;
                } else {
                    this.url_name = "#/e/" + currentExamInfo.domain + "/login";
                }
            }
        },
        getInfo: function () {
            let url;
            if(this.$route.params.batchCode){
                url ="exm_c/g/eis/{domain}/"+this.$route.params.batchCode;
            }else{
                url = "exm_c/g/eis/{domain}";
            }
            this.$http
                .get(globalProvider.serviceUrl(url), {
                    params: {
                        domain: this.$route.params.projectCode,
                        loading: true
                    }
                })
                .then(data => {
                    if (data.body.code === resultCode.Success) {
                        if(this.$route.params.batchCode){
                            data.body.data.batchCode=this.$route.params.batchCode;
                        }else{
                            data.body.data.batchCode="";
                        }
                        data.body.data.api_state = true;
                        this.$store.commit(
                            "setCurrentExamInfo",
                            data.body.data
                        );
                        this.logoUrl = data.body.data.logo_name;
                        this.examName = data.body.data.exam_name;
                        this.exam_type = data.body.data.exam_type;
                        this.domain = data.body.data.domain;
                        this.batchCode = this.$route.params.batchCode;;
                        this.font_type = data.body.data.font_type;
                        this.font_range = data.body.data.font_range;
                        this.excuseExam = data.body.data.exempt_exam_is_open;
                        if (data.body.data.url_name != null) {
                            this.url_name = "http://" + data.body.data.url_name;
                        } else {
                            this.url_name =
                                "#/e/" + data.body.data.domain + "/login";
                        }
                    } else this.$router.push({
                        name: "default.notFound"
                    });
                });
        },
        hideGrade: function () {
            return this.hideGradeDomain.indexOf(this.domain) == -1;
        }
    },
    created: function () {
        this.getData();
    }
};